import styled from 'styled-components';
import { Link as LinkR } from 'react-router-dom';
import { Link as LinkS } from 'react-scroll';

export const FooterContainer = styled.footer`
  background: var(--bg-dark);
`;

export const FooterWrap = styled.div`
  padding: 64px 24px 36px 24px;
  display: flex;
  flex-direction: column;
  max-width: var(--maxw);
  margin: 0 auto;
`;

export const FooterTop = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  width: 100%;
  gap: 40px;
  margin-bottom: 44px;

  @media screen and (max-width: 600px) {
    flex-direction: column;
    gap: 28px;
  }
`;

export const FooterBrand = styled.div`
  max-width: 380px;
`;

export const FooterLogo = styled(LinkR)`
  color: #fff;
  font-size: 1.4rem;
  font-weight: 800;
  letter-spacing: -0.03em;
  text-decoration: none;
  display: inline-block;
  margin-bottom: 16px;
`;

export const FooterAddress = styled.address`
  color: var(--on-dark-muted);
  font-style: normal;
  font-size: 0.96rem;
  line-height: 1.7;
`;

export const FooterEmail = styled.a`
  color: var(--on-dark-muted);
  text-decoration: none;

  &:hover {
    color: var(--accent);
  }
`;

export const FooterNav = styled.nav`
  display: flex;
  flex-wrap: wrap;
  gap: 14px 32px;

  @media screen and (max-width: 600px) {
    gap: 14px 24px;
  }
`;

export const FooterRouteLink = styled(LinkR)`
  color: var(--on-dark-muted);
  text-decoration: none;
  font-size: 0.96rem;
  cursor: pointer;
  transition: color 0.18s ease;

  &:hover {
    color: #fff;
  }
`;

export const FooterScrollLink = styled(LinkS)`
  color: var(--on-dark-muted);
  text-decoration: none;
  font-size: 0.96rem;
  cursor: pointer;
  transition: color 0.18s ease;

  &:hover {
    color: #fff;
  }
`;

export const FooterDivider = styled.hr`
  width: 100%;
  border: none;
  border-top: 1px solid var(--border-dark);
  margin: 0 0 24px 0;
`;

export const WebsiteRights = styled.small`
  color: var(--on-dark-muted);
  font-size: 0.86rem;
`;
